import * as i0 from "@angular/core";
export class PasskeyLoginModule {
}
PasskeyLoginModule.ɵfac = function PasskeyLoginModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PasskeyLoginModule)(); };
PasskeyLoginModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PasskeyLoginModule });
PasskeyLoginModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
